"use client";
import { jsx as e, Fragment as l } from "react/jsx-runtime";
import { createSvgIcon as i } from "@mui/material/utils";
const C = i(
  /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M18.1605 4.17016L7.40047 10.0402L7.39047 10.0502C6.66047 10.4502 6.23047 11.1802 6.23047 12.0102C6.23047 12.8402 6.66047 13.5702 7.39047 13.9702L18.1705 19.8502C18.5305 20.0502 18.9205 20.1602 19.3305 20.1602C19.7405 20.1602 20.1505 20.0502 20.5205 19.8402C21.2605 19.4102 21.7005 18.6502 21.7005 17.7902V6.22016C21.7005 5.36016 21.2605 4.60016 20.5205 4.17016C19.7805 3.74016 18.9005 3.74016 18.1605 4.17016ZM3.66023 5.00004C3.66023 4.61004 3.34023 4.29004 2.95023 4.29004C2.56023 4.29004 2.24023 4.61004 2.24023 5.00004V19C2.24023 19.39 2.56023 19.71 2.95023 19.71C3.34023 19.71 3.66023 19.39 3.66023 19V5.00004Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }),
  "KmxSkipPreviousFilled"
);
export {
  C as default
};
